import {localize} from '@/utils/i18n'

export const formTextLocalize = {
    title: localize({
        ru: 'Форма для сотрудничества',
        en: 'Application form for partnership',
        cn: '合作申请表'
    }),
    success: localize({
        ru: 'Данные успешно отправлены',
        en: 'Data sent successfully',
        cn: '数据发送成功'
    }),
    errorText: {
        exists: localize({
            ru: 'Не удалось отправить заявку! Возможно Вы уже отправляли заявку ранее.',
            en: 'Failed to send your request! You may have already sent your request before.',
            cn: 'Failed to send your request! You may have already sent your request before.'
        }),
        write: localize({
            ru: 'Ошибка при создании заявки',
            en: 'Error creating request',
            cn: 'Error creating request'
        }),
        email: localize({
            ru: 'Некорректно указан адрес электронной почты',
            en: 'The email address is incorrect.',
            cn: 'The email address is incorrect.'
        }),
        phone: localize({
            ru: 'Некорректно указан номер телефона',
            en: 'The phone number is incorrect',
            cn: '电话号码错误'
        }),
        inn: localize({
            ru: 'Некорректно указан номер ИНН',
            en: 'The Individual taxpayer number is incorrect',
            cn: '个人纳税人编号错误'
        }),
    },
    infoOrder: {
        name: localize({
            ru: 'Название компании',
            en: 'Name of your company',
            cn: '公司名称'
        }),
        resident: localize({
            ru: 'Резидент РФ',
            en: 'Russian resident company',
            cn: '俄罗斯居民公司'
        }),
        inn: localize({
            ru: 'ИНН',
            en: 'Individual taxpayer number',
            cn: '个人纳税人编号'
        }),
        actionType: localize({
            ru: 'Основные виды деятельности',
            en: 'Core business area',
            cn: '主要业务'
        }),
        productsType: localize({
            ru: 'Интересующий продукт',
            en: 'Product of your interest',
            cn: '感兴趣的产品'
        }),
        deliveryType: localize({
            ru: 'Вид доставки',
            en: 'Type of delivery',
            cn: '运输方式'
        }),
        comment: localize({
            ru: 'Комментарий',
            en: 'Comment',
            cn: '备注'
        }),
    },
    infoCustomer: {
        fio: localize({
            ru: 'ФИО / Должность',
            en: 'Name, title of a contact person',
            cn: '联系人姓名及职位'
        }),
        phone: localize({
            ru: 'Номер телефона',
            en: 'Phone number',
            cn: '电话号码'
        }),
        code: localize({
            ru: 'Код страны',
            en: 'Code of country',
            cn: '国家代码'
        }),
        email: localize({
            ru: 'Email',
            en: 'Email',
            cn: '电子邮件'
        }),
        labelPhone: localize({
            ru: 'Контактные данные',
            en: 'Contacts',
            cn: '联系方式'
        }),
    },
    products:{
        lldpe: localize({
            ru: 'Линейный полиэтилен низкой плотности',
            en: 'Linear low-density polyethylene',
            cn: '线性低密度聚乙烯'
        }),
        hdpe: localize({
            ru: 'Полиэтилен высокой плотности',
            en: 'High-density polyethylene ',
            cn: '高密度聚乙烯'
        }),
        tdpe: localize({
            ru: 'Полиэтилен технических марок',
            en: 'Technical polyethylene',
            cn: '聚乙烯过度料'
        }),
    },
    deliveries:{
        train: localize({
            ru: 'ЖД',
            en: 'By train',
            cn: '铁路运输'
        }),
        auto: localize({
            ru: 'Авто',
            en: 'By truck',
            cn: '卡车运输'
        }),
    },
    personalDataAgree: localize({
        ru: 'Нажимая кнопку «Отправить», я даю свое согласие на обработку моих персональных данных, в соответствии с Федеральным законом от&nbsp;27.07.2006&nbsp;года №152-ФЗ&nbsp;«О&nbsp;персональных&nbsp;данных», на условиях и для целей, определенных в <z-link href="/personal-data-policy/" target="_blank">Политике на обработку персональных данных</z-link>',
        en: 'By clicking the "Send" button, I give my consent to the processing of my personal data in acccordance with the Federal Law "On Personal Data" (Nº152-FZ&nbsp;from&nbsp;27.07.2006) based on and for the purposes defined in the <z-link href="https://irkutskoil.ru/personal-data-policy/" target="_blank">Policy to the processing of personal data</z-link>',
        cn: '点击“发送”按钮，即表示我同意根据《联邦个人数据法》(2006年7月27日第152-FZ号) 的规定，按照<z-link href="/files/policy.pdf" target="_blank">个人数据处理政策</z-link>中规定的条款和目的处理我的个人数据。'
    }),
    required: localize({
        ru: 'Поля помеченные * обязательны для заполнения',
        en: '* Required fields',
        cn: '标有*的字段为必填项'
    }),
    boolSelectYes: localize({
        ru: 'Да',
        en: 'Yes',
        cn: '是'
    }),
    boolSelectNo: localize({
        ru: 'Нет',
        en: 'No',
        cn: '否'
    }),
    submit: localize({
        ru: 'Отправить',
        en: 'Send',
        cn: '发送'
    }),
}
